export default __webpack_public_path__ + "801f15babbd713f0a58fc47a885f2346.svg";